import React, { createContext, useContext, useEffect, useState } from 'react';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import { env, REACT_APP_SERVER_API } from 'src/config';
import { getHeaders } from 'src/common';

const UserContext = createContext();
export const useUser = () => useContext(UserContext);
const tokenUser = () => {
  try {
    const token = localStorage.getItem('access_token');
    return token ? jwt_decode(token).user : { email: 'unknown', username: 'unknown' };
  } catch (_) { return { email: 'unknown', username: 'unknown' }; }
};

export function UserProvider({ children }) {
  const [user, setUser] = useState(tokenUser);
  useEffect(() => {
    if (!localStorage.getItem('access_token')) return;
    let active = true;
    const update = () => {
      if (document.visibilityState === 'hidden') return;
      axios.get(env(REACT_APP_SERVER_API) + 'user/profile', { headers: getHeaders() })
        .then(({ data }) => {
          if (!active || !data?.result) return;
          const fresh = data.result;
          setUser((old) => ({ ...old, ...fresh,
            membership: Array.isArray(fresh.memberships) ? (fresh.memberships[0] || null) : null }));
        })
        .catch(() => { /* Keep the last known display state; backend remains authoritative. */ });
    };
    update();
    const interval = setInterval(update, 30 * 1000);
    document.addEventListener('visibilitychange', update);
    window.addEventListener('focus', update);
    return () => { active = false; clearInterval(interval);
      document.removeEventListener('visibilitychange', update);
      window.removeEventListener('focus', update);
    };
  }, []);
  return <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>;
}
